import Modal, {ModalProps} from 'react-bootstrap/Modal';
import React, {useEffect, useState} from "react";
import {Button, Col, Figure, FloatingLabel, Form, FormLabel, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";

const MaintenanceModeModal = ({...props}: ModalProps)  => {
    const { t } = useTranslation();
    return (
        <Modal
            {...props}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body className={'p-3'}>
                <br />
                <Row>
                    <Col className={'text-center'}>
                        <Figure>
                            <Figure.Image
                                width={150}
                                src={'img/europaverde.png'} 
                                alt='europaverde_logo'
                            />
                            
                            <Figure.Caption>
                                <br/>
                                <h5>{t('messages.maintenanceMode')}</h5>
                                <p>{t('messages.maintenanceModeMessage')}</p>
                                <br/>
                                <br/>
                                <br/>
                            </Figure.Caption>
                        </Figure>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};
export default MaintenanceModeModal;
